import React from 'react'
import { Helmet } from 'react-helmet';

// Style sheet
import '../scss/mainPage.scss';

// Page content
import MainPageContent from "../../pagecontent/ts/mainPageContent";

function MainPage() {
  return (
    <div>
        <Helmet>
            <title>專業氣象 Professional Meteorology</title>
        </Helmet>
        <div className='' id=''>
            <MainPageContent />
        </div>
    </div>
  )
}

export default MainPage;

